import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App";
import 'primeflex/primeflex.css';
import "primereact/resources/themes/lara-light-blue/theme.css";
import store from "./store/index";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
<Provider store={store}>
    <App />
  </Provider>,
);
